export const HMI_TABS = [
  { key: 'overview', translationKey: 'overview', isMobileOnly: false },
  { key: 'power', translationKey: 'power', isMobileOnly: false },
  { key: 'battery', translationKey: 'battery', isMobileOnly: false },
  { key: 'assets', translationKey: 'assets', isMobileOnly: false },
  { key: 'commands', translationKey: 'commands', isMobileOnly: true },
] as const;
